import { cloudFrontUrls } from '../enum';

const env = process.env['APP_ENV'] || 'qa';

const envCFurl = `https://${cloudFrontUrls[env]}`;

// Note*: Any change here, must do in "zeus/libs/web-components/src/icons/tagAllergens.ts"

export const tagsAlergensIconUrlListMap: any = {
  1: `${envCFurl}/aio-tag-icons/vegan-1.svg`,
  2: `${envCFurl}/aio-tag-icons/chicken-2.svg`,
  3: `${envCFurl}/aio-tag-icons/beef-3.svg`,
  4: `${envCFurl}/aio-tag-icons/seafood-4.svg`,
  5: `${envCFurl}/aio-tag-icons/spicy-5.svg`,
  6: `${envCFurl}/aio-tag-icons/glutenfree-6.svg`,
  7: `${envCFurl}/aio-tag-icons/kosher-7.svg`,
  8: `${envCFurl}/aio-tag-icons/halal-8.svg`,
  9: `${envCFurl}/aio-tag-icons/beer-9.svg`,
  10: `${envCFurl}/aio-tag-icons/wine-10.svg`,
  11: `${envCFurl}/aio-tag-icons/cocktail-11.svg`,
  12: `${envCFurl}/aio-tag-icons/non-alcohalic-12.svg`,
  13: `${envCFurl}/aio-tag-icons/milk-13.svg`,
  14: `${envCFurl}/aio-tag-icons/eggs-14.svg`,
  15: `${envCFurl}/aio-tag-icons/wheat-15.svg`,
  16: `${envCFurl}/aio-tag-icons/soyabean-16.svg`,
  17: `${envCFurl}/aio-tag-icons/mustard-17.svg`,
  18: `${envCFurl}/aio-tag-icons/sesame-18.svg`,
  19: `${envCFurl}/aio-tag-icons/celery-19.svg`,
  20: `${envCFurl}/aio-tag-icons/crust-20.svg`,
  21: `${envCFurl}/aio-tag-icons/fish-21.svg`,
  22: `${envCFurl}/aio-tag-icons/oyster-22.svg`,
  23: `${envCFurl}/aio-tag-icons/treenut-23.svg`,
  24: `${envCFurl}/aio-tag-icons/peanut-24.svg`,
  25: `${envCFurl}/aio-tag-icons/assign1-25.svg`,
  26: `${envCFurl}/aio-tag-icons/assign2-26.svg`,
  27: `${envCFurl}/aio-tag-icons/assign3-27.svg`,
};
